<template>
  <in-viewport>
    <div class="projects-section">
      <base-layout>
        <border-box slot="sidebar">
          <h2>projekty:</h2>
          <project-filters-container/>
        </border-box>
        <div slot="content"><slot/></div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'
import ProjectFiltersContainer from '@/containers/Projects/ProjectFiltersContainer'

export default {
  components: {
    BaseLayout,
    BorderBox,
    ProjectFiltersContainer
  },
  props: {
    heading: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Projects/ProjectsSection.vue